import React from 'react';

export const ContentContext = React.createContext();

export const ContentProvider = ContentContext.Provider;
export const ContentConsumer = ContentContext.Consumer;
